<ng-container *ngIf="isMobile; else desktop">
  <div class="home-general-mobile">
    <div class="gallery">
      <div class="content-dots">
        <div class="dot" *ngFor="let i of [].constructor(4)"></div>
      </div>
    </div>
    <div class="content">
      <div class="search">
        <div class="text"></div>
      </div>
      <div class="title"></div>
      <div class="box-buttons">
        <div class="box-container" *ngFor="let i of [].constructor(5)">
          <div class="box">
            <div class="icon"></div>
          </div>
          <span></span>
        </div>
      </div>
      <div class="title-section"></div>
      <div class="subtitle-section"></div>
      <div class="box-buttons">
        <div class="box-container" *ngFor="let i of [].constructor(5)">
          <div class="box image">
            <div class="image"></div>
          </div>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #desktop>
  <div class="home-general-container">
    <div class="search-home-section"></div>
    <div class="first-home-section">
      <div class="first-home-section-title"></div>
      <div class="first-home-section-images-container">
        <div class="first-home-section-image" *ngFor="let i of [].constructor(3)"></div>
      </div>
    </div>
    <div class="second-home-section">
      <div class="second-home-section-title"></div>
      <div class="second-home-section-images-container">
        <div class="second-home-item-image" *ngFor="let i of [].constructor(10)"></div>
      </div>
    </div>
    <div class="third-home-section">
      <div class="third-home-section-title"></div>
      <div class="third-home-section-images-container">
        <div class="container-section">
          <div class="image"></div>
          <div class="text-container">
            <div class="first-text">
              <span class="text-1"></span>
              <span class="text-2"></span>
            </div>
            <div class="second-text">
              <span class="text-3"></span>
              <span class="text-4"></span>
            </div>
          </div>
        </div>
        <div class="container-section">
          <div class="image"></div>
          <div class="text-container">
            <div class="first-text">
              <span class="text-1"></span>
              <span class="text-2"></span>
            </div>
            <div class="second-text">
              <span class="text-3"></span>
              <span class="text-4"></span>
            </div>
          </div>
        </div>
        <div class="container-section">
          <div class="image"></div>
          <div class="text-container">
            <div class="first-text">
              <span class="text-1"></span>
              <span class="text-2"></span>
            </div>
            <div class="second-text">
              <span class="text-3"></span>
              <span class="text-4"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="fourth-home-section">
        <div class="fourth-home-section-title"></div>
        <div class="fourth-home-section-images-container">
          <div class="destination-container">
            <div class="fourth-home-section-image"></div>
            <div class="destination-name"></div>
          </div>
          <div class="destination-container">
            <div class="fourth-home-section-image"></div>
            <div class="destination-name"></div>
          </div>
          <div class="destination-container">
            <div class="fourth-home-section-image"></div>
            <div class="destination-name"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-template>